import type {RuleValidationErrors} from '../types';
import {VisualType} from './constants';
import type {VisualRule} from './types';
import {createValidationObject} from '../../utils/createValidationObject';

function isHexColor(hex: any) {
	if (typeof hex !== 'string') return false;
	hex = hex.replace(/^#/, '');
	const length = hex.length;
	return length === 6 || (length === 3 && !isNaN(Number('0x' + hex)));
}

export const validateVisualRule = <T extends VisualRule = VisualRule>(
	rule: T,
): RuleValidationErrors | false => {
	if (
		rule.elementSubType1 === VisualType.COLOR &&
		!isHexColor(rule.elementValue1)
	)
		return {
			elementValue1: createValidationObject(),
		};

	if (
		rule.elementSubType1 === VisualType.ASSET &&
		(!Number.isInteger(Number(rule.elementValue1)) ||
			(rule.elementValue1 as any) === 0)
	)
		return {
			elementValue1: createValidationObject(),
		};

	return false;
};

export default validateVisualRule;
